module.exports = __webpack_public_path__ + "img/underling.a35378f7.jpg";